import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import performRequest from "../../../api/request";
import { Toast } from "../../../CustomComponent/toast";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import LoadingPage from "../../../Components/layouts/loading";
import StepRoutes from "../../../Routes/steps_routes";
import { FcMoneyTransfer, FcPaid } from "react-icons/fc";
import Footer from "../../../Components/Footer/footer";
import SimpleButton from "../../../Components/layouts/simple_button";

const ShopifyProductView = () => {
  const { id } = useParams();
  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchProduct = () => {
    setLoading(true);
    performRequest("GET", `/shpkOrder/fetch-inventory/${id}`)
      .then((res) => {
        if (res.status === 200) {
  
          setProduct(res.data.product);
        } else {
          Toast("error", "Error while fetching product details!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    fetchProduct();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  // if (loading) {
  //   return (
  //     <div className="container py-5 text-center">
  //       <div className="spinner-border" role="status"></div>
  //       <p className="text-muted mt-2">Loading product details…</p>
  //     </div>
  //   );
  // }
  if (loading) {
    return <LoadingPage />;
  }

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xl">
          <div className="page-header d-print-none">
            <div className="row g-2 align-items-center">
              <div className="col">
                <h2 className="page-title mb-1">
                  <FcPaid></FcPaid>View Product Details
                </h2>
                <h4 className="text-muted">
                  <StepRoutes />
                </h4>
              </div>
            </div>
          </div>
          <div className="container-xl py-4">
            {/* Product Info */}
            <div className="card mb-4">
              <div className="card-body">
                <div className="row g-4">
                  {/* Images */}
                  <div className="col-md-5 p-4">
                    {product?.images?.length > 0 ? (
                      <img
                        src={product.images[0].src}
                        alt={product.title}
                        className="img-fluid rounded shadow-sm"
                      />
                    ) : (
                      <div className="text-muted text-center p-5 border rounded">
                        No images available
                      </div>
                    )}
                  </div>

                  {/* Details */}
                  <div className="col-md-7">
                    <p className="mb-2">
                      <span className="badge text-bg-secondary me-2">
                        {product?.status || "N/A"}
                      </span>
                    </p>
                    {product?.title && (
                        <div className="fw-bold fs-3 mt-2">
                          {product?.title}
                        </div>
                      )}
                      <hr></hr>
                    {product?.body_html && (
                      <div
                        className="text-muted"
                        dangerouslySetInnerHTML={{ __html: product?.body_html }}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>

            {/* Variants */}
            <h2 className="mb-3 fs-1 text-center">Variants</h2>
            <hr></hr>
            <div className="row g-3">
              {product?.variants?.map((variant) => (
                <div className="col-md-6" key={variant.id}>
                  <div className="card shadow-sm h-100">
                    <div className="card-body">
                      <h6 className="card-title fw-bold">
                        Pack of {variant?.title}
                      </h6>
                      <ul className="list-unstyled  mb-0">
                        <li>
                          <strong>SKU:</strong> {variant?.sku || "—"}
                        </li>
                        <li>
                          <strong>Price:</strong> ₹{variant?.price}
                        </li>
                        <li>
                          <strong>Weight:</strong> {variant?.weight || 0}
                          {variant.weight_unit}
                        </li>
                        <li>
                          <strong>In Stock:</strong>{" "}
                          {variant?.inventory_quantity != null
                            ? variant?.inventory_quantity
                            : "N/A"}
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              ))}

              {(!product?.variants || product?.variants.length === 0) && (
                <div className="col-12 text-center text-muted py-4">
                  No variants available
                </div>
              )}
            </div>
          </div>
          <hr></hr>
          <div className="card-footer">
            <div className="btn-list justify-content-end">
              <SimpleButton
                buttonText="Edit Product Details"
                href={`/shopify-product/edit/${id}`}
              />
              <SimpleButton buttonText="Cancel" type="secondary" />
            </div>
          </div>
        </div>

        <Footer />
      </div>
    </div>
  );
};

export default ShopifyProductView;
